export const DORMITORY_MODULE_ID = "dormitory";

export const ROOM_STATUSES = ["available", "occupied", "maintenance", "inactive"] as const;
export const LEASE_STATUSES = ["draft", "active", "ended", "cancelled"] as const;
export const METER_TYPES = ["water", "electric"] as const;
export const BILLING_PERIOD_STATUSES = ["draft", "calculated", "closed"] as const;
export const BILL_STATUSES = ["draft", "issued", "paid", "cancelled"] as const;
export const RENT_CHARGE_TIMINGS = ["start_of_period", "end_of_period", "manual"] as const;
export const PRORATE_POLICIES = ["none", "daily"] as const;
export const UTILITY_BILLING_MODES = ["metered", "flat", "included"] as const;

export const DEFAULT_DORMITORY_SETTINGS = {
  defaultRentAmount: 0,
  defaultWaterRate: 18,
  defaultElectricRate: 8,
  defaultServiceCharge: 0,
  defaultDueDay: 5,
  gracePeriodDays: 3,
  rentChargeTiming: "start_of_period",
  billingCycleStartDay: 1,
  invoiceIssueDay: 1,
  proratePolicy: "daily",
  utilityBillingMode: "metered",
  advanceRentMonths: 1,
  depositMonths: 1,
  lateFeeAmount: 0,
  lateFeeType: "fixed",
} as const;
